module.exports = __webpack_public_path__ + "img/Bill.b79d852e.png";